import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Card, Typography } from '@altermaind/web/ui';
import { VerticalStepper } from '@/_shared/components/VerticalStepper';
import { Step } from '@/_shared/components/VerticalStepper/types';
import { Routes } from '@/_shared/constants/routes';
import { getEmployerNotCompletedSurveysCall } from '@/surveys/state/api';

export const SurveyNotCompleted = () => {
  const t = useTranslations('dashboard.learning.surveyNotCompleted');
  const navigate = useNavigate();
  const { response: responseGetEmployerNotCompletedSurveys } =
    getEmployerNotCompletedSurveysCall.hook();

  const steps: Step[] = [
    responseGetEmployerNotCompletedSurveys?.map(survey => ({
      title: survey.templateName || t('steps.title'),
      description: (
        <Box>
          <Typography variant='p3/light'>
            {t(`steps.description.${survey.templateName}`)}
          </Typography>
          <Button
            onClick={() =>
              survey.campaignId
                ? navigate(Routes.SurveyToComplete.replace(':campaignId', survey.campaignId))
                : null
            }
            mt='s'
            variant='positive'
          >
            {t('steps.ctaLabel')}
          </Button>
        </Box>
      ),
      isCompleted: false,
      iconName: 'survey',
    })) || [],
  ].flat();

  return (
    <Box mb='s'>
      <Typography variant='h2' mb='xs'>
        {t('title')}
      </Typography>
      <Card>
        <VerticalStepper primaryStyle noBorder steps={steps} />
      </Card>
    </Box>
  );
};
